<style src="css/consult.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="咨询订单"></topbar>
        <div class="consultList" v-if="!emptyStatus">
            <div class="consultItem" v-for="item in userBespeakList" @click="to(`serveInfo?bespeakId=${item.scaleUserBespeak.bespeakId}`)">
                <div class="topBox">
                    {{item.scaleUserBespeak.serveType | isServeType}}
<!--                    <span :class="{active:item.scaleUserBespeak.status===1,active2:item.scaleUserBespeak.status===2,active3:item.scaleUserBespeak.status===0}">{{item.scaleUserBespeak.status | isStatus}} <span v-if="item.scaleUserBespeak.status==0" style="color: red">（请补全信息）</span></span>-->
                    <span>{{item.scaleUserBespeak.status | isStatus}} <span v-if="item.scaleUserBespeak.status==0" style="color: red">（请补全信息）</span></span>
                </div>
<!--                <div class="line"></div>-->
                <div class="mainBox">
                    <div class="doctorImg" :style="{background: `url(${EnvUrl}${item.chatDoctor.doctorWorkPhoto}) no-repeat center/cover`}"></div>
                    <div class="mainRight">
                        <div class="doctorName">
                            {{item.chatDoctor.doctorName}}
                            <div class="doctorHospitalLevel">{{item.chatDoctor.doctorHospitalLevel}}</div>
                        </div>

                        <div class="mrItemBox" v-if="JSON.parse(item.scaleUserBespeak.troubles).length>0"><span><span v-for="item in JSON.parse(item.scaleUserBespeak.troubles)">{{item}}</span></span></div>

                        <div class="mrItemBox" v-if="item.scaleUserBespeakSchedules"  v-for="(v,i) in item.scaleUserBespeakSchedules"><span>第{{i+1}}/{{item.totalCount}}次</span><span>{{v.bespeakDate | time}}<span>{{v.status | isStatus}}</span></span></div>

                        <div class="mrItemBox"  v-if="!item.scaleUserBespeakSchedules"><span>{{item.scaleUserBespeak.bespeakDate}}</span></div>
                        <div class="mrItemBox" v-if="item.scaleUserBespeak.remark"><span>{{item.scaleUserBespeak.remark}}</span></div>
                    </div>
                </div>
                <div class="tabList">
                    <div class="tabItem" v-if="item.scaleUserBespeak.status===3" @click.stop="to(`evaluate?bespeakId=${item.scaleUserBespeak.bespeakId}&doctorId=${item.chatDoctor.doctorId}`)">评价服务</div>
                    <div class="tabItem active" v-if="item.scaleUserBespeak.status===3 || item.scaleUserBespeak.status===4" @click.stop="to(`expertDetail?doctorId=${item.chatDoctor.doctorId}`)">再次预约</div>
                    <div class="tabItem active" v-if="item.scaleUserBespeak.serveType!==3&&item.scaleUserBespeak.status===2" @click.stop="to(`reply?bespeakId=${item.scaleUserBespeak.bespeakId}`)">进入咨询</div>
                    <div class="tabItem active" v-if="item.scaleUserBespeak.status===0 || item.scaleUserBespeak.status===1" @click.stop="openMask(item.scaleUserBespeak.bespeakId)">取消预约</div>
                </div>
            </div>
            <no-more-data :noMoreData="noMoreData"></no-more-data>
        </div>
        <div class="emptyBox" v-if="emptyStatus">
            <div class="emptyImg"></div>
            <div class="emptyName">还没有相关咨询哦~</div>
        </div>
        <div class="maskBox" v-if="maskStatus">
            <div class="mask">
                <div class="maskTop">
                    <div class="maskTitle">说明取消原因</div>
                    <textarea maxlength="30" placeholder="最多输入30个字" v-model="remark"></textarea>
                </div>
                <div class="btnBox">
                    <div class="btn" @click="cancle">取消</div>
                    <div class="btn active" @click="cancelUserBespeak">提交</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                remark:'',
                bespeakId:'',
                userBespeakList:[],
                pageSize: 10,
                pageIndex: 1,
                noMoreData: false,
                isLoading: false,
                emptyStatus: false,
                maskStatus: false,
                count: 0
            }
        },
        components: {
            noMoreData,
            topbar,
            Swiper,
            Slide,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isStatus(v){
                let arr = ['预约中','待咨询','进行中','已完成','已取消']
                return arr[v]
            },
            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            }
        },
        computed: {},
        methods: {
            cancle(){
                this.maskStatus = false
                this.bespeakId = ''
            },
            openMask(id){
                this.bespeakId=id;
                this.maskStatus=true;
            },
            to(n){
                this.$router.push(n)
            },
            async cancelUserBespeak() {
                let obj = {}
                obj.bespeakId = this.bespeakId;
                obj.userId = localStorage.getItem('userId');
                obj.remark = this.remark;
                let data = await getSources("/bear-scale/api/scaleUserBespeak/cancelUserBespeak.json", obj);
                if (data.status === 0) {
                    this.cancle();
                    this.pageIndex=1;
                    this.userBespeakList=[];
                    this.getUserBespeakList();
                }else{
                    alert(data.msg)
                }
            },
            async getUserBespeakList() {
                let obj = {}
                obj.userId = localStorage.getItem('userId');
                obj.pageIndex = this.pageIndex;
                obj.pageSize = this.pageSize;
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getUserBespeakList.json", obj);
                if (data.status === 0) {
                    this.isLoading = false;
                    this.count = data.count;
                    this.doctor = data.doctor;
                    this.userBespeakList = [...this.userBespeakList, ...data.userBespeakList];
                    if (data.userBespeakList.length == 0) {
                        this.emptyStatus = true
                    } else {
                        if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                            this.noMoreData = true
                        } else {
                            this.noMoreData = false
                        }
                    }
                }else{
                    alert(data.msg)
                }
            },
            handleScroll() {
//                console.log(11)
                let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                let bottomOfWindow = document.documentElement.offsetHeight - scrolltop - window.innerHeight <= 200
                if (bottomOfWindow && this.isLoading == false) {

                    if (this.pageIndex >= Math.ceil(this.count / this.pageSize)) {
                        this.noMoreData = true
                    } else {
                        this.isLoading = true;
                        this.pageIndex = this.pageIndex + 1;
                        this.getUserBespeakList()
                    }
                }
            },
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.getUserBespeakList()
            window.addEventListener('scroll', this.handleScroll);//监听页面滚动事件
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/consult.vue?d8ff88e2